import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import NoticeForm from "../_components/NoticeForm";
import styles from "../Notice.module.css";
import apiService from "../../../../services/api";
import { setupAutoLogout } from "../../../../utils/auth";

export default function FormClient() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id'); // 수정 모드인지 확인
    const [noticeData, setNoticeData] = useState(null);
    const [loading, setLoading] = useState(false);
    
    // 인증 확인 및 자동 로그아웃 설정
    useEffect(() => {
        if (!apiService.isAuthenticated()) {
            navigate("/admin/login");
            return;
        }

        // 토큰 만료 시 자동 로그아웃 설정
        const cleanup = setupAutoLogout(() => {
            console.log('Notice form auto logout triggered');
            navigate("/admin/login");
        });

        // API 서비스에 토큰 만료 콜백 등록
        apiService.setTokenExpiredCallback(() => {
            console.log('Notice form API service token expired callback');
            navigate("/admin/login");
        });

        return cleanup;
    }, [navigate]);
    
    // 수정 모드일 때 기존 데이터 가져오기
    useEffect(() => {
        if (id) {
            const fetchNoticeData = async () => {
                setLoading(true);
                try {
                    const response = await apiService.getNoticeById(id);
                    setNoticeData(response);
                } catch (error) {
                    console.error('공지사항 데이터 가져오기 실패:', error);
                    alert('공지사항 정보를 가져오는데 실패했습니다.');
                    navigate("/admin/notices");
                } finally {
                    setLoading(false);
                }
            };
            
            fetchNoticeData();
        }
    }, [id, navigate]);
    
    const handleSubmit = () => {
        // 성공 후 공지사항 탭으로 돌아가기
        navigate("/admin/notices?tab=notice");
    };
    
    const handleCancel = () => {
        // 취소 시 공지사항 탭으로 돌아가기
        navigate("/admin/notices?tab=notice");
    };

    if (loading) {
        return (
            <div className={styles.noticeWrap}>
                <div className={styles.SubPageWidth}>
                    <div className={styles.header}>
                        <h1>공지사항 수정</h1>
                        <button onClick={handleCancel} className={styles.backBtn}>
                            목록으로
                        </button>
                    </div>
                    <div style={{ textAlign: 'center', padding: '50px' }}>
                        데이터를 불러오는 중...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.noticeWrap}>
            <div className={styles.SubPageWidth}>
                <div className={styles.header}>
                    <h1>{id ? "공지사항 수정" : "공지사항 등록"}</h1>
                    <button onClick={handleCancel} className={styles.backBtn}>
                        목록으로
                    </button>
                </div>
                
                <NoticeForm 
                    item={noticeData} // 실제 공지사항 데이터 전달
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            </div>
        </div>
    );
}